import { OpenInNew, RemoveCircle } from '@mui/icons-material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Box, IconButton, Menu, MenuItem, Stack } from '@mui/material'
import React from 'react'
import theme from 'shared/style/theme'

export interface PermissionsActionsProps {
    isAdmin: boolean
    onRemoveUser: () => void
    onMakeAdmin: () => void
    onImpersonate: () => void
}

const PermissionsActions: React.FC<PermissionsActionsProps> = ({
    isAdmin,
    onRemoveUser,
    onMakeAdmin,
    onImpersonate,
}) => {
    const [open, setOpen] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
        setOpen(true)
    }
    const handleMenuClose = () => {
        setAnchorEl(null)
        setOpen(false)
    }
    const actionMenu = (
        <Menu
            id="action-menu"
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            MenuListProps={{
                'aria-labelledby': 'action-button',
            }}
            sx={{
                border: '1px solid',
                borderColor: 'other.lightBorder',
            }}
            onClick={() => setOpen(!open)}
            open={open}
            onClose={() => handleMenuClose}
            anchorEl={anchorEl}
        >
            <MenuItem onClick={onRemoveUser}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <RemoveCircle sx={{ color: theme.palette.grey[600] }} />
                    <Box>Remove User</Box>
                </Stack>
            </MenuItem>
            {!isAdmin && (
                <MenuItem onClick={onMakeAdmin}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Box sx={{ width: 24 }} /> {/* Placeholder for icon */}
                        <Box>Make Admin</Box>
                    </Stack>
                </MenuItem>
            )}
            <MenuItem onClick={onImpersonate}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <OpenInNew sx={{ color: theme.palette.grey[600] }} />
                    <Box>Impersonate</Box>
                </Stack>
            </MenuItem>
        </Menu>
    )
    return (
        <Box display="flex" justifyContent="flex-start" alignItems="flex-start">
            <IconButton
                id="action-button"
                aria-controls={open ? 'action-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleMenuOpen}
            >
                <MoreVertIcon />
            </IconButton>
            {open && actionMenu}
        </Box>
    )
}

export default PermissionsActions
